import { BoxDetailMacroProps } from '@/box/interface'
import { Column } from '@/shared/Column'
import { TemplateMacroTable } from '@/template/macros/table'
import React from 'react'

export const BoxDetailMacros: React.FC<BoxDetailMacroProps> = (
  props: BoxDetailMacroProps
) => {
  const { contactTemplate } = props
  const columns: Column[] = [{ index: 3, hidden: true }]

  return (
    <div>
      <TemplateMacroTable columns={columns} data={contactTemplate?.macros} />
    </div>
  )
}
